<template>
    <div class="card-doctor">
        <panel-ms class="card-doctor__foto" :class="mini?'card-doctor__foto-mini':''">
            <a v-if="link!=''" :href="link">
                <img :src="value&&value.img?value.img:fotoDefault" alt="">
                <div class="mini" v-if="mini" @click="$emit('click',value)">
                    <h3>{{value.main!=1?value.post:value.post_shorts}}</h3>
                    <p>{{value.fio}}</p>
                </div>
            </a>
            <a v-if="link==''">
                <img :src="value&&value.img?value.img:fotoDefault" alt="">
                <div class="mini" v-if="mini" @click="$emit('click',value)">
                    <h3>{{value.main!=1?value.post:value.post_shorts}}</h3>
                    <p>{{value.fio}}</p>
                </div>
            </a>
        </panel-ms>
        <div class="card-doctor__data" v-if="!mini">
            <h3 v-if="value!=null&&value.fio">
                {{value.fio}}
            </h3>
            <h4 v-if="value!=null&&value.post">
                {{value.post}}
            </h4>
            <div v-if="value!=null&&value.open_hours">
                <h4 style="margin-bottom: 5px;">Часы приема</h4>
                <p>{{value.open_hours}}</p>
            </div>
            <a :href="'tel:'+value.tel_shotr">{{value.tel}}</a>
            <a :href="'mailto:'+value.mail">{{value.mail}}</a>
        </div>
    </div>
</template>
<script>
import panelMs from './panelMs.vue';
export default{
    components:{
        panelMs
    },
    props:{
        value:{type:Object,default:null},
        mini:{type:Boolean,default:false},
        link:{type:String,default:''}
    },
    data(){
        return{
            fotoDefault:'http://mosp51.ru/files/img/service/fotodefault.png'
        }
    }
}
</script>
<style>
.card-doctor{
    display: flex;
    gap:32px
}
.card-doctor img{
    height: 212px;
}
.card-doctor .card-doctor__data{
    display: flex;
    gap: 16px;
    flex-direction: column;
}
.card-doctor h3{
    font-size: 16px;
    color:#0D3041;
    margin: 0;
}
.card-doctor p,
.card-doctor h4,
.card-doctor a{
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height:130%
}
.panel.panel__button .card-doctor a{
      font-weight: 400;
}
.card-doctor h4{
    color: #919191;
}
.card-doctor p{
    color:#0D3041;
}
.card-doctor a{
    color:#174E72;
    text-decoration: none;
}
.card-doctor a:hover{
    color:#007BB8;
}
.card-doctor__foto{
    flex: none;
}
.card-doctor .card-doctor__foto-mini{
    width: 306px;
    height: 346px;
    padding: 32px 25px;
}
.card-doctor .card-doctor__foto-mini a{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.card-doctor .card-doctor__foto-mini h3{
    margin-bottom: 8px;
    font-weight: 500;
}
.card-doctor .card-doctor__foto-mini h3,
.card-doctor .card-doctor__foto-mini p{
    font-size: 14px;
    text-align: center;
}
@media (max-width: 1000px){
    .card-doctor{
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }
    .card-doctor img{
        height: 100px;
    }
    .card-doctor__foto{
        display: flex;
        justify-content: center;
    }
    .card-doctor p,
    .card-doctor h4,
    .card-doctor a{
        font-size: 14px;
    }
    .main__body > div{
        gap: 0;
    }
    .card-doctor .card-doctor__foto-mini img{
        border-radius: 10px;
        box-shadow: 0 0 40px 0 #EEEEEE66, 0 5px 5px 0 #E5EDF5;
        background-color:#FFF ;
        width: 100%;
        object-fit: contain;
    }
    .card-doctor .card-doctor__foto-mini{
        width: 100%;
        box-shadow: none;
        background-color: transparent;
        height: fit-content;
        padding: 0;
    }
    .card-doctor .card-doctor__foto-mini a{
        gap:8px;
        width: 100%;
    }
    .card-doctor h3{
        font-size: 14px;
    }

}
</style>